<template>
  <div class="bgcolorg">
    <DemoCheckoutModal />
    <demo-login-modal />
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-sm-12">
          <h3>Review Your Booking</h3>
        </div>
        <div class="col-md-4 col-sm-12">
          <h3>Tariff Details</h3>
        </div>
      </div>
      <div class="row" v-if="roomdata">
        <div class="col-md-8 col-sm-12 room-booked">
          <div class="row">
            <div class="col-md-4">
              <carousel
                class="roomcarousel"
                v-if="roomdata.room_images.split(',').length > 0"
                :navigationEnabled="false"
                :paginationEnabled="true"
                :scrollPerPage="true"
                :perPage="1"
                :perPageCustom="[
                  [480, 1],
                  [768, 1],
                  [1199, 1],
                ]"
                :autoplay="true"
                :loop="true"
                :interval="10000"
                :speed="720"
              >
                <slide
                  v-bind:key="rimgindex"
                  v-for="(rimg, rimgindex) in roomdata.room_images.split(',')"
                >
                  <img
                    v-lazy="
                      'https://hotellele.com/fcrm/uploads/hotel_rooms/' + rimg
                    "
                    class="imgsize"
                  />
                </slide>
              </carousel>
              <h5 class="mt-2">
                <strong>{{ roomdata.room_name }}</strong>
              </h5>
            </div>
            <div class="col-md-8">
              <h5>
                {{ roomdata.hoteldata.hotel_name }}
                <span>
                  <i
                    v-for="index in Number(roomdata.hoteldata.hotel_stars)"
                    v-bind:key="index"
                    class="fa fa-star fa-xs starsize"
                    aria-hidden="true"
                  ></i>
                </span>
              </h5>
              <p>{{ roomdata.hoteldata.hotel_address }}</p>
              <div class="boxed">
                <div class="cb-top">
                  <h6>Check-In</h6>
                  <h6>
                    <strong
                      >{{ checkindate }}
                      {{ roomdata.hoteldata.checkin_time }}</strong
                    >
                  </h6>
                </div>
                <small></small>
              </div>

              <div class="boxed">
                <div class="cb-top">
                  <h6>Check-Out</h6>
                  <h6>
                    <!-- <Button
                      @click="showcheckoutpopup"
                      class="btn btn-info"
                      style="max-width: 90%"
                      v-if="checkoutdate == 'Invalid date'"
                    >
                      Select Date
                    </Button> -->
                    <strong v-if="checkoutdate != 'Invalid date'"
                      >{{ checkoutdate }}
                      {{ roomdata.hoteldata.checkout_time }}</strong
                    >
                  </h6>
                </div>
                <small> </small>
              </div>
              <div
                v-if="checkoutdate != 'Invalid date'"
                class="text-center mt-2"
              >
                <!-- <Button
                  @click="showcheckoutpopup"
                  class="btn btn-sm btn-info"
                  style="max-width: 70%"
                >
                  Change Dates
                </Button> -->
              </div>

              <div class="days mt-3">
                <!-- <h5>3 Days & 2 Nights</h5> -->
                <h5>{{ noofguests }}</h5>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4>Inclusion:</h4>
              <div
                class="room_inclusions"
                v-html="roomdata.room_inclusions"
              ></div>
            </div>
          </div>
          <h6 class="mt-4" style="display: none">
            <small
              >Cancellation Policy: Full refund if you cancel this booking
              within 12 hours.</small
            >
            <!-- <a href>View More</a> -->
          </h6>
        </div>

        <div class="col-md-4 col-sm-12 room-booked price">
          <div v-if="combohotel == 'hotel'" class="pricebox">
            <!-- <h6>
              {{ Math.ceil(noofrooms) }} Rooms Gross Total:
              <strong
                >₹ {{ roomdata.room_gross_price * Math.ceil(noofrooms) }}
              </strong>
            </h6>

            <h6>
           
              {{ Math.ceil(noofrooms) }} Rooms Discounts:
              <strong class="red"
                >₹
                {{
                  roomdata.room_gross_price * Math.ceil(noofrooms) -
                  roomdata.room_price * Math.ceil(noofrooms)
                }}</strong
              ><br />
            </h6>

            <h6>
              {{ Math.ceil(noofrooms) }} Rooms Price :
              <strong
                >₹ {{ roomdata.room_price * Math.ceil(noofrooms) }}</strong
              >
            </h6> -->
            <!-- <hr /> -->
            <!-- <span hidden>
              {{
                Math.ceil((totalRoom = maxguest / roomdata.room_total_person))
              }}</span
            > -->

            <!-- <hr /> -->
            <h4 class="priceing">
              <!-- {{ Math.ceil(noofrooms) }} Rooms x {{ diffdate }} Nights
              <strong class="blue"
                >₹ {{ roomdata.room_price * Math.ceil(noofrooms) * diffdate }}
              </strong> -->

              <!-- <br /> -->
              <div v-if="discount_value > 0">
                Promo Discount
                <strong class="promo"> ₹{{ discount_value }}</strong>
              </div>
              <!-- <hr /> -->
              You Pay:
              <span @click="isShowing ^= true" class="inform">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-info-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                  />
                  <path
                    d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                  />
                </svg>
              </span>

              <strong class="green" v-if="totalRoom == 1">
                ₹
                {{
                  totalPay +
                  ((guests - roomdata.max_adults) * roomdata.extra_per_adults +
                    (guestsChildren - roomdata.max_children) *
                      roomdata.extra_per_children_under_six +
                    (guestsChildrenabove - roomdata.max_children) *
                      roomdata.extra_per_children_more_six) *
                    diffdate -
                  discount_value
                }}
                <!-- {{ totalPay- discount_value }} -->
              </strong>
              <strong class="green" v-else-if="totalRoom > 1">
                ₹
                {{ totalRoom * roomdata.room_price }}
              </strong>
            </h4>

            <div v-show="isShowing">
              <table id="extratable">
                <tr>
                  <th colspan="5" id="firstrow">Details</th>
                </tr>
                <tr class="detailtable">
                  <th>
                    No Day <span class="pricedivider">x</span>
                    Price
                  </th>
                  <th>No Of Rooms</th>
                  <th>Total Price</th>
                  <th v-if="weekendcount > 0">
                    No Days<span class="pricedivider"><br />x<br /> </span>
                    Price
                  </th>

                  <th v-if="weekendcount > 0">Total Price</th>
                </tr>
                <tr>
                  <td>
                    {{ weekdayscount }}<span class="pricedivider"> x </span>
                    {{ roomdata.room_price }}
                  </td>
                  <td>{{ totalRoom }}</td>
                  <td>
                    {{
                      parseFloat(
                        weekdayscount * roomdata.room_price * totalRoom
                      ).toFixed(2)
                    }}
                  </td>

                  <td v-if="weekendcount > 0">
                    {{ weekendcount }} <span class="pricedivider"> x </span>
                    {{ roomdata.room_price_weekend }}
                  </td>
                  <td v-if="weekendcount > 0" class="colortotal">
                    {{
                      parseFloat(
                        weekendcount * roomdata.room_price_weekend * totalRoom
                      ).toFixed(2)
                    }}
                  </td>
                </tr>
                <tr v-if="weekendcount > 0" class="colortotal">
                  <td colspan="3">Total Amount</td>
                  <td>
                    {{
                      parseFloat(
                        (weekdayscount * roomdata.room_price +
                          weekendcount * roomdata.room_price_weekend) *
                          totalRoom
                      ).toFixed(2)
                    }}
                  </td>
                </tr>
                <tr v-else-if="weekendcount == 0" class="colortotal">
                  <td colspan="2">Total Amount</td>
                  <td>
                    {{
                      parseFloat(
                        (weekdayscount * roomdata.room_price +
                          weekendcount * roomdata.room_price_weekend) *
                          totalRoom
                      ).toFixed(2)
                    }}
                  </td>
                </tr>
              </table>
              <table
                class="extrapersontable"
                id="extratable"
                v-if="guests > roomdata.max_adults && Math.ceil(noofrooms) == 1"
              >
                <tr>
                  <td colspan="5" id="firstrow">Extra Person Charges</td>
                </tr>
                <tr>
                  <th>Title</th>
                  <th>
                    Exter Person <br />
                    x <br />Base Price
                  </th>
                  <th>Total Nights</th>
                  <th>Total Price</th>
                </tr>
                <tr
                  v-if="
                    guests > roomdata.max_adults &&
                    Math.ceil(maxguest / roomdata.room_total_person) == 1
                  "
                >
                  <td>
                    <span class="tableth"><b> Adults </b></span>
                  </td>
                  <td>
                    <span style="color: #6978e8; font-weight: 900">
                      {{ guests - roomdata.max_adults }}
                      <span class="pricedivider"> x </span>
                      {{ Math.round(roomdata.extra_per_adults, 0) }}</span
                    >
                  </td>
                  <td>{{ diffdate }}</td>
                  <td>
                    {{
                      (guests - roomdata.max_adults) *
                      roomdata.extra_per_adults *
                      diffdate
                    }}
                  </td>
                </tr>
                <tr
                  v-if="
                    guestsChildren > 0 &&
                    roomdata.extra_per_children_under_six > 0
                  "
                >
                  <td>
                    <span class="tableth">
                      <b>Child Blow 6 Year</b>
                    </span>
                  </td>
                  <td>
                    <span style="color: #6978e8; font-weight: 900"
                      >{{ guestsChildren - roomdata.max_children
                      }}<span class="pricedivider"> x</span>
                      {{
                        Math.round(roomdata.extra_per_children_under_six, 0)
                      }}</span
                    >
                  </td>

                  <td>{{ diffdate }}</td>
                  <td>
                    {{
                      (guestsChildren - roomdata.max_children) *
                      roomdata.extra_per_children_under_six *
                      diffdate
                    }}
                  </td>
                </tr>

                <tr
                  v-if="
                    guestsChildrenabove > roomdata.max_children &&
                    roomdata.extra_per_children_more_six > 0
                  "
                >
                  <td>
                    <span class="tableth">
                      <b>Child Above 6 Year </b>
                    </span>
                  </td>
                  <td>
                    <span style="color: #6978e8; font-weight: 900"
                      >{{ guestsChildrenabove - roomdata.max_children
                      }}<span class="pricedivider"> x</span>
                      {{
                        Math.round(roomdata.extra_per_children_more_six, 0)
                      }}</span
                    >
                  </td>
                  <td>{{ diffdate }}</td>
                  <td>
                    {{
                      (guestsChildrenabove - roomdata.max_children) *
                      roomdata.extra_per_children_more_six *
                      diffdate
                    }}
                  </td>
                </tr>
                <tr class="extrapersontotal">
                  <td colspan="3">Total Extra Person Charges</td>
                  <td>
                    {{
                      (exterchanges =
                        (guests - roomdata.max_adults) *
                          roomdata.extra_per_adults *
                          diffdate +
                        (guestsChildren - roomdata.max_children) *
                          roomdata.extra_per_children_under_six *
                          diffdate +
                        (guestsChildrenabove - roomdata.max_children) *
                          roomdata.extra_per_children_more_six *
                          diffdate)
                    }}
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div v-if="combohotel == 'combe'" class="pricebox">
            <h6>
              {{ Math.ceil(maxguest) }} Person Gross Total :
              <strong
                >₹
                {{ roomdata.hoteldata.combo_gross_amt * Math.ceil(maxguest) }}
              </strong>
            </h6>

            <h6>
              <!-- $roomresult->room_price_weekend; -->
              {{ Math.ceil(maxguest) }} Person Discounts:
              <strong class="red"
                >₹
                {{
                  roomdata.hoteldata.combo_gross_amt * Math.ceil(maxguest) -
                  roomdata.hoteldata.combo_net_amt * Math.ceil(maxguest)
                }}</strong
              ><br />
            </h6>

            <h6>
              {{ Math.ceil(maxguest) }} Person Price :
              <strong
                >₹
                {{
                  roomdata.hoteldata.combo_net_amt * Math.ceil(maxguest)
                }}</strong
              >
            </h6>
            <hr />
            <h4 class="priceing">
              {{ Math.ceil(maxguest) }} Person x {{ diffdate }} Nights
              <strong class="blue"
                >₹
                {{ roomdata.hoteldata.combo_net_amt * Math.ceil(maxguest) }}
              </strong>
              <div v-if="discount_value > 0">
                Promo Discount
                <strong class="promo"> ₹{{ discount_value }}</strong>
              </div>
              <hr />
              You Pay:
              <strong class="green"
                >₹
                {{
                  roomdata.hoteldata.combo_net_amt * Math.ceil(maxguest) -
                  discount_value
                }}
              </strong>
            </h4>
          </div>
          <hr />
          <!-- <p>&nbsp;</p> -->
          <h3>Promo Code</h3>
          <h6>Select a Promo Code</h6>
          <input
            type="input"
            name="promocode"
            v-model="promocode"
            value
            :disabled="discount_value > 0.1"
            class="form-control"
            placeholder="Promo Code"
          />
          <div v-show="showPromoError" class="alert alert-warning mt-2">
            {{ errorPromoString }}
          </div>
          <div v-show="discount_value > 0.01" class="alert alert-success mt-2">
            Promocode Discount of INR {{ discount_value }} applied succesfully
          </div>
          <span class="mt-5">{{ promotext }}</span>
          <button
            v-if="discount_value < 0.1"
            @click.prevent="checkPromocode"
            class="btn btn-primary mt-3 text-center primaryBtn"
          >
            Apply
          </button>
          <button
            v-if="discount_value > 0.1"
            @click.prevent="removePromocode"
            class="btn btn-danger mt-3 text-center primaryBtn"
          >
            Remove
          </button>

          <!-- <h6>
            Total Savings:
            <strong class="green">₹ {{ roomdata.room_price * 0.1 }}</strong>
          </h6> -->
        </div>
      </div>

      <div class="row" v-if="!roomdata">
        <div class="alert alert-info">Please wait...</div>
      </div>

      <div class="row mt-3">
        <div class="col-md-8 col-sm-12">
          <h3>Enter Traveller Details</h3>
        </div>
        <!-- <div class="col-md-4 col-sm-12">
          <h3>Promo Code</h3>
        </div> -->
      </div>
      <div class="row">
        <div class="col-md-8 col-sm-12 blankcolor">
          <form action method="post">
            <div class="row mobile">
              <div class="col-md-3 col-sm-12">
                <label for="ContactDetails"
                  >Contact Details <span class="redcolor">*</span></label
                >
              </div>
              <div class="col-md-5 col-sm-12">
                <input
                  type="input"
                  name="ContactDetails"
                  class="form-control"
                  v-model="form.email"
                  value
                  placeholder="Your E-Mail"
                  required
                  title=""
                />
              </div>
              <div class="col-md-4 col-sm-12">
                <input
                  type="input"
                  name="Mobileno"
                  v-model="form.mobile"
                  class="form-control"
                  value
                  placeholder="Your Mobile Number"
                  required
                  title=""
                />
              </div>
              <div class="col-md-12 col-sm-12 text-center ml-11">
                <small
                  >Your booking details will be sent to this email address and
                  mobile number.</small
                >
              </div>
            </div>
            <div v-for="(s) in Number(noofrooms)" v-bind:key="s">
              <hr />
              Room {{ s  }}
            <div
              v-for="(g, i) in guestDetails"
              v-bind:key="i"
              class="row mobile mt-3"
            >
              <div class="col-md-3 col-sm-12">
                <label for="room">
                  Guest Details {{ i + 1 }}
                
                  <span v-if="i == 0">
                    <span class="redcolor">*</span>
                  </span>
                </label>
              </div>
              <div class="col-md-5 col-sm-12">
                <input
                  type="input"
                  :name="`firstName-${s}-${i+1}`"
                  class="form-control"
                  v-model="g.firstName"
                  value
                  placeholder="Guest First Name"
                  required
                  title=""
                />
              </div>
              <div class="col-md-4 col-sm-12">
                <input
                  type="input"
                  :name="`lastname-${s}-${i+1}`"
                  class="form-control"
                  v-model="g.lastName"
                  value
                  placeholder="Guest Last Name"
                  required
                  title=""
                />
              </div>
              </div>
            </div>

            <hr />
            <div class="row mobile">
              <div class="col-md-3 col-sm-12">
                <label for="room">Special Request:</label>
              </div>
              <div class="col-md-9 col-sm-12">
                <textarea
                  name="specialrequest"
                  class="form-control"
                  v-model="form.specialreq"
                  value
                  placeholder="e.g. Im allergic to peanuts"
                ></textarea>
                <small
                  >Special request can't be guaranteed. We will pass these
                  requests to the hotels.</small
                >
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12 col-sm-12">
                <h3>Add your Billing (GST) Details (Optional)</h3>
                <small
                  >Claim credit of GST charges. Your taxes may get updated post
                  submitting your GST details.</small
                >
              </div>
            </div>
            <hr />
            <div class="row mt-5 gst">
              <div class="col-md-2">
                <label for="gstnumber">GST Number:</label>
              </div>
              <div class="col-md-4">
                <input
                  type="input"
                  v-model="form.gst"
                  name="gstno"
                  class="form-control"
                  value
                  placeholder="GST No"
                />
              </div>
              <div class="col-md-2">
                <label for="companyname">Company Name:</label>
              </div>
              <div class="col-md-4">
                <input
                  type="input"
                  name="companyname"
                  class="form-control"
                  v-model="form.companyname"
                  value
                  placeholder="Company Name"
                />
              </div>
            </div>
            <div class="row mt-3 gst">
              <div class="col-md-2">
                <label for="mailid">Email Id:</label>
              </div>
              <div class="col-md-4">
                <input
                  type="input"
                  name="mailid"
                  v-model="form.cemail"
                  class="form-control"
                  value
                  placeholder="EMail"
                />
              </div>
              <div class="col-md-2">
                <label for="Mobile">Mobile Number</label>
              </div>
              <div class="col-md-4">
                <input
                  type="input"
                  name="Mobile"
                  v-model="form.cmobile"
                  class="form-control"
                  value
                  placeholder="Mobile"
                />
              </div>
            </div>
            <div class="row mt-3 gst">
              <div class="col-md-2">
                <label for="Address">Address:</label>
              </div>
              <div class="col-md-4">
                <input
                  type="input"
                  name="Address"
                  v-model="form.caddress"
                  class="form-control"
                  value
                  placeholder="Billing Address"
                />
              </div>
              <div class="col-md-2">
                <label for="City">City:</label>
              </div>
              <div class="col-md-4">
                <input
                  type="input"
                  name="City"
                  v-model="form.ccity"
                  class="form-control"
                  value
                  placeholder="City"
                />
              </div>
            </div>
            <div class="row mt-3 gst">
              <div class="col-md-2">
                <label for="Pincode">Pincode:</label>
              </div>
              <div class="col-md-4">
                <input
                  type="input"
                  name="Pincode"
                  v-model="form.cpincode"
                  class="form-control"
                  value
                  placeholder="Pincode"
                />
              </div>
            </div>

            <div class="row text-center mt-5">
              <div class="col-lg-12">
                <div v-show="showError" class="alert alert-warning mt2">
                  {{ errorString }}
                </div>
                <button
                  @click.prevent="processOrder"
                  class="btn btn-success primaryBtn"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
        <!-- <div class="col-md-3 col-sm-12 blankcolor height">
          <h6>Select a Promo Code</h6>
          <input
            type="input"
            name="promocode"
            v-model="promocode"
            value
            class="form-control"
            placeholder="Promo Code"
          />
          <div v-show="showPromoError" class="alert alert-warning mt-2">{{ errorPromoString }}</div>
          <span class="mt-5">{{ promotext }}</span>
          <button
            @click.prevent="checkPromocode"
            class="btn btn-primary mt-3 offset-3 text-center primaryBtn"
          >check</button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { APIURLS } from "../../api/constants";
import moment from "moment";
import DemoCheckoutModal from "../modals/modal_checkout";
import DemoLoginModal from "../modals/modal_login";
import { log } from "console";

export default {
  name: "HotelBookingMiddle",
  components: {
    DemoCheckoutModal,
    DemoLoginModal,
  },
  props: {
    roomid: String,
  },

  data() {
    return {
      noofguests: "",
      noofrooms: "",
      checkindate: "",
      checkoutdate: "",
      showError: false,
      showPromoError: false,
      errorString: "",
      errorPromoString: "",
      promotext: "",
      discount: 0,
      is_percent: false,
      discount_msg: "",
      discount_value: 0,
      promocode: "",
      guestdetaillastname: "",
      guestdetailname: "",
      roomdata: null,
      exterchanges: 0,
      diffdate: 0,
      weekdayscount: 0,
      weekendcount: 0,
      totalPay: 0,
      isShowing: false,
      maxguest: localStorage.getItem("totalguest"),
      guests: localStorage.getItem("guests"),
      guestsChildren: localStorage.getItem("guestsChildren"),
      guestsChildrenabove: localStorage.getItem("guestsChildrenabove"),
      combohotel: localStorage.getItem("combohotel"),
      totalRoom: localStorage.getItem("trooms"),
      //guestDetails: [{firstName: "", lastName: "" }],
      guestDetails:'',
      form: {
        email: "",
        mobile: "",
        specialreq: "",
        cemail: "",
        cmobile: "",
        companyname: "",
        gst: "",
        caddress: "",
        ccity: "",
        cpincode: "",
      },
    };
  },
  methods: {
    addGuests() {
      var Tempguests = localStorage.getItem("guests");
      this.guestDetails = [{firstName: "", lastName: "" }];
      
      for (var i = 1; i < Number(this.noofrooms); i++) {
        this.guestDetails.push({ firstName: "", lastName: "" });
      }
      
      //console.log("GD: "+ this.guestDetails.length);
      //console.log("NOOFR: "+ this.noofrooms);
    },

    showcheckoutpopup() {
      this.$modal.show("modal-checkout");
    },
    processOrder() {
      var islog = localStorage.getItem("loggedIn");
      if (islog == "yes") {
        if (this.form.email == "" || this.form.name == "") {
          // this.$router.push({ path: 'bookhotel', query: { roomid: roomid } });
          this.errorString = "Please enter the required fields to continue";
          this.showError = true;
        } else if (this.checkoutdate == "Invalid date") {
          this.errorString = "Please enter the correct checkout date";
          this.showError = true;
        } else {
          var formData = new FormData();
          for (var key in this.form) {
            formData.append(key, this.form[key]);
          }
          var sub_total =
            this.roomdata.room_price * this.noofrooms * this.weekdayscount +
            this.roomdata.room_price_weekend *
              this.noofrooms *
              this.weekendcount;

          var total =
            this.roomdata.room_price * this.noofrooms * this.weekdayscount +
            this.roomdata.room_price_weekend *
              this.noofrooms *
              this.weekendcount +
            this.exterchanges -
            this.discount_value;

          formData.append("customer", localStorage.getItem("customer_id"));
          formData.append("comment", "true");
          formData.append("total_items", "1");
          formData.append(
            "subject",
            "Hotel Booking by " + localStorage.getItem("name")
          );
          var content = "";
          var pricedetails = "";
          var gadults = localStorage.getItem("guests");
          var gkids = localStorage.getItem("guestsChildren");
          var gAbovekids = localStorage.getItem("guestsChildrenabove");

          content += "HotelName:" + this.roomdata.hoteldata.hotel_name + ",";
          content += "RoomName:" + this.roomdata.room_name + ",";
          content += "RoomID:" + this.roomdata.room_id + ",";
          content += "CheckInDate:" + this.checkindate + ",";
          content += "CheckOutDate:" + this.checkoutdate + ",";
          content += "adults:" + gadults + ",";
          content += "kidsless6:" + gkids + ",";
          content += "kidsabove6:" + gAbovekids + ",";
          content += "Promocode:" + this.promocode + ",";

          formData.append("status", "2");
          formData.append("assigned", "1");
          var totaldiscount = formData.append("sub_total", sub_total);
          formData.append("total_discount", this.discount_value);
          formData.append("total_tax", "0");
          var extaradult = gadults - this.roomdata.max_adults;
          var extarchildless = gkids - this.roomdata.max_children;
          var extarchildabove = gAbovekids - this.roomdata.max_children;

          pricedetails += "RoomPriceWeekday:" + this.roomdata.room_price + ",";
          pricedetails +=
            "RoomPriceWeekend:" + this.roomdata.room_price_weekend + ",";
          pricedetails += "NoOfWeekDay:" + this.weekdayscount + ",";
          pricedetails += "NoOfWeekend:" + this.weekendcount + ",";
          pricedetails += "RoomNo:" + this.noofrooms + ",";
          pricedetails += "PromoValue:" + this.discount_value + ",";
          pricedetails += "ExtraPersonCharges:" + this.exterchanges + ",";
          pricedetails += "Totaldates:" + this.diffdate + ",";
          pricedetails += "ExtraAdults:" + extaradult + ",";
          pricedetails += "Extrakidsless6:" + extarchildless + ",";
          pricedetails += "Extrakidsabove6:" + extarchildabove + ",";

          formData.append("pricedetails", pricedetails);
          formData.append("extra_person_charges", this.exterchanges);
          formData.append("total", total);
          var guestnumber = 1;
          for (let index = 0; index < this.guestDetails.length; index++) {
            formData.append(
              "guests_details[" + guestnumber + "]fname",
              this.guestDetails[index].firstName
            );
            formData.append(
              "guests_details[" + guestnumber + "]lname",
              this.guestDetails[index].lastName
            );
            content +=
              "Guest " +
              guestnumber +
              " FirstName:" +
              this.guestDetails[index].firstName +
              ",";
            content +=
              "Guest " +
              guestnumber +
              " LastName:" +
              this.guestDetails[index].lastName +
              ",";
            guestnumber++;
          }
console.log(content);
          formData.append("items[0][name]", "Hotel Booking");
          formData.append("items[0][product_id]", this.roomdata.room_id);
          formData.append(
            "items[0][code]",
            this.roomdata.hoteldata.hotel_id + "-" + this.roomdata.room_id
          );
          formData.append(
            "items[0][description]",
            "{name:Hotel Booking" +
              "," +
              "hotelname:" +
              this.roomdata.hoteldata.hotel_name +
              "," +
              "checkindate:" +
              this.this.checkindate +
              "," +
              "checkdate:" +
              this.checkoutdate +
              "," +
              "adults:" +
              gadults +
              "," +
              "kidsblowsixyear:" +
              gkids +
              "," +
              "kidsabovesixyear:" +
              gAbovekids +
              "," +
              "weekday:" +
              this.weekdayscount +
              "," +
              "weekend:" +
              this.weekendcount +
              "," +
              "totalnight:" +
              this.diffdate +
              "," +
              "noofperson:" +
              guestnumber +
              "," +
              "subTotal:" +
              (this.roomdata.room_price * this.noofrooms * this.weekdayscount +
                this.roomdata.room_price_weekend *
                  this.noofrooms *
                  this.weekendcount) +
              "extragrandtotal:" +
              this.exterchanges +
              "}"
          );
          var Itemdiscount = (this.discount_value / sub_total) * 100;
          formData.append("items[0][quantity]", this.noofrooms);
          formData.append("items[0][dates]", this.diffdate);
          formData.append("items[0][total]", total);
          formData.append("items[0][unit]", "Unit");
          formData.append("items[0][extra_person_charges]", this.exterchanges);
          formData.append("items[0][price]", sub_total);
          formData.append("items[0][tax]", "0");
          formData.append(
            "items[0][hotel_id]",
            this.roomdata.hoteldata.hotel_id
          );
          formData.append("items[0][room_id]", this.roomdata.room_id);
          formData.append("items[0][discount]", Itemdiscount.toFixed(2));
          formData.append(
            "date",
            moment(String(new Date())).format("YYYY-DD-MM")
          );
          formData.append(
            "opentill",
            moment(String(new Date())).add(12, "days").format("YYYY-DD-MM")
          );
          formData.append("checkindate", this.checkindate);
          formData.append("checkoutdate", this.checkoutdate);
          formData.append("adults", localStorage.getItem("guests"));
          formData.append("children", localStorage.getItem("guestsChildren"));
          formData.append("hotel_id", this.roomdata.hoteldata.hotel_id);
          formData.append("room_id", this.roomdata.room_id);
          formData.append("content", content);
console.log(formData);
          axios.post(APIURLS.BOOK_URL, formData).then((response) => {
            this.showLoading = false;
            var data = response.data;
            if (data.success) {
              // this.showSuccess = true;
              this.$router.push({
                path: "orderdone",
                query: { orderid: data.id },
              });
            } else {
              this.errorString = data.message;
              this.showError = true;
            }
            //console.log(response);
          });
        }
      } else {
        this.$modal.show("demo-login", {
          show: true,
        });
      }
    },
    removePromocode() {
      this.discount_value = 0;
      this.discount = 0;
      this.is_percent = false;
    },
    checkPromocode() {
      if (this.promocode == "") {
        this.showPromoError = true;
        this.errorPromoString =
          "Please enter a valid Promo Code to get intended discounts";
      } else {
        var fd = new FormData();
        fd.append("promocode", this.promocode);
        axios.post(APIURLS.VALIDATE_PROMOCODE, fd).then((response) => {
          if (response.data != null) {
            if (!response.data.success) {
              this.showPromoError = true;
              this.errorPromoString = response.data.message;
            } else {
              if (response.data.coupon.coupon_name != null) {
                if (response.data.coupon.coupon_name != "") {
                  this.discount = response.data.coupon.coupon_value;
                  this.discount_msg = response.data.coupon.coupon_message;
                  if (response.data.coupon.coupon_type == "Percent") {
                    this.is_percent = true;
                    if (this.is_percent) {
                      var AmtWeekdayGross =
                        this.roomdata.room_price * this.weekdayscount;
                      var amtWeekEndGross =
                        this.roomdata.room_price_weekend * this.weekendcount;
                      var finalAmtForDiscount =
                        AmtWeekdayGross + amtWeekEndGross;
                      //console.log(finalAmtForDiscount);
                      var dd = (finalAmtForDiscount * this.discount) / 100;
                      // console.log(dd);
                      // var dd = (this.totalPay * this.discount) / 100;
                      this.discount_value = dd;
                    }
                  } else {
                    this.discount_value = parseFloat(this.discount);
                  }
                  this.showPromoError = false;
                  this.errorPromoString = "";
                } else {
                  this.showPromoError = true;
                  this.errorPromoString = "Invalid Coupon Code";
                }
              } else {
                this.showPromoError = true;
                this.errorPromoString = "Invalid Coupon Code";
              }
            }
          } else {
            this.showPromoError = true;
            this.errorPromoString = "Invalid Coupon Code";
          }
        });
      }
    },
    getRoomDetail() {
      axios
        .post(
          APIURLS.GET_ROOM_DETAIL +
            "?roomid=" +
            this.roomid +
            "&checkindate=" +
            moment(localStorage.getItem("checkin")).format("YYYY-MM-DD") +
            "&checkoutdate=" +
            moment(localStorage.getItem("checkout")).format("YYYY-MM-DD"),
          {
            roomid: this.roomid,
            checkindate: moment(localStorage.getItem("checkin")).format(
              "YYYY-MM-DD"
            ),
            checkoutdate: moment(localStorage.getItem("checkout")).format(
              "YYYY-MM-DD"
            ),
          }
        )
        .then((response) => {
          this.roomdata = response.data;
          var weekendday = this.roomdata.room_weekend_days;
          var stuffArray = weekendday.split(",");
          var SearchIndex = stuffArray.indexOf(dayofWeek);
          var dayofWeek = moment(localStorage.getItem("checkout")).format(
            "dddd"
          );
          this.weekdayscount = this.roomdata.weekdaysCountSingle;
          this.weekendcount = this.roomdata.weekendCountSingle;
          if (SearchIndex == -1) {
            this.weekdayscount = this.weekdayscount - 1;
          } else {
            this.weekendcount = this.weekendcount - 1;
          }
          var priceWeekdayGross =
            this.weekdayscount * this.roomdata.room_gross_price;
          var priceWeekdayNet = this.weekdayscount * this.roomdata.room_price;
          var priceweekendGross =
            this.weekendcount * this.roomdata.room_weekend_gross_price;
          var priceweekendNet =
            this.weekendcount * this.roomdata.room_price_weekend;
          // console.log("weekend" + this.weekendcount);
          // console.log("weekday" + this.weekdayscount);
          // console.log("gross" + priceWeekdayGross);
          // console.log("net" + priceWeekdayNet);
          // console.log("Gross Weekend" + priceweekendGross);
          // console.log("net weekend" + priceweekendNet);
          this.totalPay = priceWeekdayNet + priceweekendNet;

          // console.log("Room Detail:" + JSON.stringify(this.roomdata));
        });
    },
    processDates() {
      var g = localStorage.getItem("guests");
      var gc = localStorage.getItem("guestsChildren");
      var gca = localStorage.getItem("guestsChildrenabove");
      var tr = localStorage.getItem("trooms");
      if (g != null && gc != null) {
        if (g != "" && gc != "") {
          this.noofguests = "Adults: " + g;
          if (gc > 0) {
            +" - Children Blow 6 Year: " + gc;
          }
          if (gca > 0) {
            +"- Children Above 6 Year :" + gca;
          }
        }
      }
      if (tr != null) {
        this.noofrooms = tr;
      }
      var dateIn = localStorage.getItem("checkin");
      var dateOut = localStorage.getItem("checkout");
      if (dateIn != null && dateOut != null) {
        if (dateIn != "" && dateOut != "") {
          //console.log("DIN: " + dateIn);
          //console.log("DOut: " + dateOut);
          this.checkindate = moment(dateIn).format("DD MMM YYYY");
          this.checkoutdate = moment(dateOut).format("DD MMM YYYY");
        }
      }
      this.$forceUpdate();
    },
  },

  mounted() {
    var Indate = moment(localStorage.getItem("checkin")).format("YYYY-MM-DD");
    var Outdate = moment(localStorage.getItem("checkout")).format("YYYY-MM-DD");
    var now = moment(Indate),
      end = moment(Outdate),
      days = end.diff(now, "days");
    this.diffdate = days;
    // alert(this.diffdate);
    // alert('2');
  },
  created() {
    //alert('first');
    var tr = localStorage.getItem("trooms");
    if (tr != null) {
      this.noofrooms = tr;
      this.addGuests();
    }
    var ref = this;
    this.$root.$on("checkoutupdated", function (data) {
      if (data == "updated") {
        //console.log("Checkout Event Sent");
        ref.processDates();
        ref.addGuests();
      }
    });
    //console.log("RoomID: " + this.roomid);
    if (this.roomid) {
      if (this.roomid != "") {
        this.getRoomDetail();
      }
    }
    this.processDates();
  },
};
</script>

<style scoped>
/*-------------------Room booking-----------------------*/

.green {
  color: #048620;
}
.red {
  color: red;
}
.blue {
  color: #11cdef;
}
.promo {
  color: red;
  float: right;
}
.bgcolorg {
  background-color: #f4f5f7;
}
.height {
  max-height: 55vh;
}
.ml-11 {
  margin-left: 11%;
}
.pricebox > h6 > strong {
  float: right;
}

.col-md-8 {
  max-width: 65%;
}
.room-booked {
  margin: 0.5rem 0.3rem;
  padding: 1rem;
  background-color: #fff;
  border-radius: 15px;
}
#firstrow {
  background-color: #4caf50;
  color: #fff;
  font-size: 1.2em;
  font-weight: 800;
  text-align: center;
}
.tableth {
  font-size: 0.9em;
}
#extratable {
  margin-top: 3em;
  width: calc(100% - 1%);
}
#extratable tr th,
#extratable tr td,
#extra tr td {
  border: 1px solid #000;
}
#extratable tr th,
#extratable tr td {
  padding: 0 0.5em;
}
#extratable tr th {
  font-size: 0.9em;
}
#extratable tr td {
  font-size: 0.9em;
}
/* #extra tr td:nth-last-child(3) {
  padding: 0 1em;
}
#extra tr td:nth-last-child(2) {
  padding: 0 1em;
}
#extra tr td:nth-last-child(1) {
  padding: 0 1em;
} */

.imgsize {
  width: 100%;
}
.starsize {
  width: 15px;
  font-size: 0.9rem;
  margin-right: 0.1rem;
}

.boxed {
  width: 40%;
  /* height: 32%; */
  padding-bottom: 1em;
  border-radius: 3px;
  border: 1px solid #f1f1f1;
  background-color: #f1f1f1;
  text-align: center;
  position: relative;
  margin-right: 8px;
  color: #666;
  display: inline-block;
  border-radius: 15px;
}

.cb-top {
  padding-top: 1rem;
}

.days {
  position: relative;
  display: inline-block;
  font-size: 1rem;
  font-weight: 200;
}

.blankcolor {
  background-color: #fff;
  padding: 1rem;
  margin: 0.5rem 0.3rem;
  border-radius: 15px;
}
.priceing > strong {
  float: right;
}
.price > h6 > strong {
  float: right;
}

.gst > .col-md-2 {
  border: unset;
}
/* :nth-of-type(1n+10) */
.room_inclusions::v-deep li {
  display: inline-block;
}

.room_inclusions::v-deep li::before {
  content: "\2713";
  display: inline-block;
  color: #048620;
  padding: 0 6px 0 0;
}
.room_inclusions::v-deep li::after {
  content: ".";
  display: inline-block;
  padding: 0 6px 0 0;
}
.inform {
  cursor: pointer;
  transition: all 0.5s ease-in-out;
}
.inform:hover {
  color: #11cdef;
}
.detailtable {
  font-size: 0.8em;
}
.section-shaped .shape-style-1 :nth-child(3),
.section-shaped .shape-style-1 :nth-child(4) {
  background: transparent !important;
}
.pricedivider {
  color: #6978e8;

  font-size: 1em;
  font-weight: 900;
}
.colortotal {
  color: #6978e8;
  font-size: 1em;
  font-weight: 900;
}
.extrapersontable {
  font-size: 0.8em;
}
.extrapersontotal {
  font-size: 1.3em;
  color: #6978e8;
  font-weight: 900;
}
@media (min-width: 300px) and (max-width: 769px) {
  .mobile > .col-sm-12 {
    margin-bottom: 1rem;
  }
  .col-md-8 {
    max-width: 100%;
  }
}
.redcolor {
  color: red;
}
</style>